<template>

  <v-card
    class="rounded-0 pa-7"
    elevation="0"
  >
    <v-card-title class="titreBoite"> {{$tc('accueil.BoiteInfoGenerales.titre')}} </v-card-title>

    <div v-html="appStore.texteDynamique.BlocTexte2">
    </div>

    <v-expansion-panels
      flat
      class="rounded py-2 pb-0 mt-5"
      style="min-height: 52px; !important"
      id="listeCalendrier"
      v-model="panneauOuvert"
    >
      <PanneauExtension
        class="mb-0"
        :titre="$tc('accueil.BoiteInfoGenerales.panneauExtension.titre')"
      >
        <CoursOffertsTable />
      </PanneauExtension>
    </v-expansion-panels>

    <div v-html="appStore.texteDynamique.BlocTexte3">
    </div>

  </v-card>
</template>

<script>
import useAppStore from '@/store/appStore';
import CoursOffertsTable from './CoursOffertsTable.vue';
import PanneauExtension from '../custom/PanneauExtension.vue';

export default {
  name: 'BoiteInfoGenerales',
  components: {
    CoursOffertsTable,
    PanneauExtension,
  },
  setup() {
    const appStore = useAppStore();

    return { appStore };
  },
  data() {
    return {
      panneauOuvert: null,
    };
  },
  created() {
  },
  computed: {
  },
  methods: {
    ouvrirTableCSS() {
      this.panneauOuvert = 0;
    },
  },
};
</script>
